import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import NavbarList from './navbar.list';

const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-white shadow-md">
      <div className="max-w-7xl mx-auto px-4">
        <nav className="flex items-center justify-between h-20">

          {/* Logo */}
          <Link to="/" className="flex items-center gap-3">
            <img
              src={require('../../assets/logo.png')}
              alt="Logo"
              className="w-16 h-16 object-contain"
            />
            <span className="text-gray-900 font-bold text-3xl tracking-wide">
              TrendVerse
            </span>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-6">
            <NavbarList />
          </div>

          {/* Mobile Toggle */}
          <button
            onClick={() => setOpen(!open)}
            className="md:hidden text-gray-900 text-3xl hover:text-blue-600 transition"
          >
            {open ? '✕' : '☰'}
          </button>

        </nav>
      </div>

      {/* Mobile Slide Menu */}
      <div
        className={`
          md:hidden fixed top-16 left-0 w-full h-screen
          bg-white text-gray-900
          transform transition-transform duration-300
          ${open ? 'translate-x-0' : '-translate-x-full'}
        `}
      >
        <div className="p-6">
          <NavbarList closeMenu={() => setOpen(false)} />
        </div>
      </div>
    </header>
  );
};

export default Navbar;
